import React from 'react'
import Block from '../block';

const ContentfulBlockListContent = (listContent) => {
     let className = '';
     if (listContent.layoutTemplate) {
          className = listContent.layoutTemplate.replace(/ /g, '-').toLowerCase();
     }

     return (
          <ul className={`block-list-content ${className}`}>
               {listContent.itemList && listContent.itemList.map((item, i) => {
                    return (
                         <li key={i}>
                              {
                                   listContent.displayNumber ? (
                                        <>
                                             <span className="the-index">{i + 1}</span>
                                             <span className="the-content">
                                                  <Block block={item} />
                                             </span>
                                        </>
                                   ) : (
                                             <Block block={item} />
                                        )
                              }
                         </li>
                    )
               })}
          </ul>
     )
}

export { ContentfulBlockListContent }
